export default __webpack_public_path__ + "static/media/Picture12.88a7e623.png";